// Library Import
import React, { useEffect } from 'react';

// Redux Import
import { useDispatch, useSelector } from 'react-redux';

// Modal Import
import { ConfirmModal } from './ConfirmModal';
import { AlertModal } from './AlertModal';

// Modal State Enum
import { ModalState, setModalState } from '../../../../store/modules/modal';
import ModalBase from '../ModalBase';

const ModalCase = () => {
  const dispatch = useDispatch();
  /** reduxr에서 상태 받아오기 */
  const modalState = useSelector(
    (state: { modal: { modalState: ModalState } }) => state.modal.modalState
  );

  const confirmText = useSelector(
    (state: { modal: { confirmText: string } }) => state.modal.confirmText
  );

  const alertText = useSelector(
    (state: { modal: { alertText: string } }) => state.modal.alertText
  );

  /** redux state 완료상태로 */
  const setStateDone = () => {
    dispatch(setModalState(ModalState.PROCESS_DONE));
  };

  /** redux state api 진행상태로 */
  const setStateConfirm = () => {
    dispatch(setModalState(ModalState.CONFIRM_ALLOW));
  };

  /** 확인모달 */
  const AwaitConfirmCase = () => {
    return (
      <ModalBase>
        <ConfirmModal
          onClose={setStateDone}
          onConfirm={setStateConfirm}
          text={confirmText}
        />
      </ModalBase>
    );
  };

  /** 알림모달(성공, 실패 공유. 텍스트만 달라짐) */
  const AwaitAlertCase = () => {
    return (
      <ModalBase>
        <AlertModal onClose={setStateDone} text={alertText} />
      </ModalBase>
    );
  };

  /** 실제 return될 component 초기상태는 null */
  let modalContent = null;

  /** 조건부로 component 대입 */
  switch (modalState) {
    case ModalState.CONFIRM_AWAIT:
      modalContent = <AwaitConfirmCase />;
      break;

    case ModalState.ALLERT_NOW:
      modalContent = <AwaitAlertCase />;
      break;

    default:
      modalContent = null;
      break;
  }

  useEffect(() => {}, [modalState]);

  return modalContent;
};

export default ModalCase;

//   switch (modalState) {
//     case ModalState.PROCESS_IDLE:
//       return null;
//     case ModalState.CONFIRM_AWAIT:
//       return <AwaitConfirmCase />;
//     case ModalState.CONFIRM_ALLOW:
//       if (callBack !== null) {
//         callBack();
//       }
//       allowConfirmModal();
//       return null;

//     case ModalState.CONFIRM_CANCEL:
//       processDone();
//       return null;
//     case ModalState.ALLERT_NOW:
//       return <AlertCase />;
//     default:
//       return null;
//   }
